export const getProTimeLeft = (
    startDate: number,
    limit: number
): string => {
    const timeLeft = (limit - (Date.now() - startDate)) / 1000;
    const minutes = Math.floor(timeLeft / 60);
    const seconds = Math.floor(timeLeft - minutes * 60);
    return (minutes > 9 ? minutes : '0' + minutes )+ ':' + (seconds > 9 ? seconds : '0' + seconds);
}
